import cybertronLogger, { Message } from '@cybertron/logger/lib/main';
import { GLOBAL } from '../constants/Global';

const logger = (payload: Message | string) => {
  let transformedPayload: Message = {
    msg: ''
  };
  if (typeof payload === 'string') {
    transformedPayload.msg = payload;
  } else {
    transformedPayload = payload;
  }
  if (!transformedPayload?.extras) {
    transformedPayload.extras = {};
  }

  cybertronLogger.log({
    msg: transformedPayload.msg || '',
    extras: {
      ...transformedPayload.extras,
      agentId: GLOBAL.AGENT_ID
    },
    type: transformedPayload.type || 'log'
  });
};

export default logger;
